import { Container } from 'pixi.js';

export function addHoverEffect(container: Container, over = 0.75, out = 1) {
    container.on('pointerover', () => {
        container.alpha = over;
    });

    container.on('pointerout', () => {
        container.alpha = out;
    });
}
